"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlignmentIconMap = exports.AlignmentsFormat = exports.VerticalAlignments = exports.Alignments = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _AlignmentsFormat;

var Alignments = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
  NONE: 'none',
  JUSTIFY: 'justify'
};
exports.Alignments = Alignments;
var VerticalAlignments = {
  BOTTOM: 'baseline',
  MIDDLE: 'middle',
  TOP: 'top'
};
exports.VerticalAlignments = VerticalAlignments;
var AlignmentsFormat = (_AlignmentsFormat = {}, (0, _defineProperty2.default)(_AlignmentsFormat, Alignments.LEFT, 'alignleft'), (0, _defineProperty2.default)(_AlignmentsFormat, Alignments.CENTER, 'aligncenter'), (0, _defineProperty2.default)(_AlignmentsFormat, Alignments.RIGHT, 'alignright'), (0, _defineProperty2.default)(_AlignmentsFormat, Alignments.JUSTIFY, 'alignjustify'), (0, _defineProperty2.default)(_AlignmentsFormat, Alignments.NONE, ''), _AlignmentsFormat);
exports.AlignmentsFormat = AlignmentsFormat;
var AlignmentIconMap = {
  left: 'imageAlignmentLeft',
  center: 'imageAlignmentMiddle',
  right: 'imageAlignmentRight',
  none: 'inline',
  baseline: 'blockAlignmentBottom',
  middle: 'blockAlignmentCenter',
  top: 'blockAlignmentTop'
};
exports.AlignmentIconMap = AlignmentIconMap;